import { axiosDelete, axiosGet, axiosPatch, axiosPost, axiosPut } from "./axiosService";

const autoInvestUrl = 'autoInvestment/configuration';
const loansUrl = 'Loans';
const autoInvestPreviewUrls = 'auto-investment-preview';

export class AutoInvestmentService {
  getAutoInvestment() {
    return axiosGet(null, autoInvestUrl);
  }

  updateAutoInvestment(form) {
    return axiosPatch(autoInvestUrl, form);
  }

  requestPreview(loanId) {
    return axiosPost(null, `${loansUrl}/${loanId}/${autoInvestPreviewUrls}`);
  }

  getPreview(loanId) {
    return axiosGet(null, `${loansUrl}/${loanId}/${autoInvestPreviewUrls}`, null, null, { hide_toaster: true });
  }

  updatePreview(loanId, form) {
    return axiosPut(form, `${loansUrl}/${loanId}/${autoInvestPreviewUrls}`);
  }

  distributePreview(loanId) {
    return axiosPut(null, `${loansUrl}/${loanId}/${autoInvestPreviewUrls}/distribute`);
  }

  deletePreview(loanId) {
    return axiosDelete(`${loansUrl}/${loanId}/${autoInvestPreviewUrls}`);
  }
}